<script>
import FormTemplatesFormCell from '@/views/FormTemplates/components/FormTemplatesFormCell.vue'
import { SheetCellTypeMethods, SheetCellTypes } from '@/typings/api/FormTemplate'

export const createDefaultDependenceValueData = () => ({
  cell_uuid: null,
  sheet_uuid: null,
  list: [],
})

export const createDefaultDependenceData = () => ({
  type: null,
  list: [],
})

export const createDefaultData = (code, uuid) => ({
  name: `Ячейка ${code}`,
  uuid,
  description: '',
  hint: '',
  code: `C$${code}`,
  type: SheetCellTypes.number,
  type_method: SheetCellTypeMethods.manual,
  required: true,
  unique: false,
  customColumnWidth: false,
  dependence: createDefaultDependenceData(),

  list: [],

  auto_start: 1,

  number_from: null,
  number_to: null,

  string_min: null,
  string_max: null,
  string_long: false,

  date_from: null,
  date_to: null,

  formula: null,

  list_cell: null,

  list_handbook: null,

  dep_list_sheet_uuid: null,
  dep_list_cell_uuid: null,
  dep_list_values: null,
})

export default {
  name: 'PassportTemplatesCell',
  extends: FormTemplatesFormCell,
}
</script>
